import type { Node } from "@tiptap/pm/model"
import type { Transaction } from "@tiptap/pm/state"

// Details persist their `open` flag in the doc, so expanding an FAQ to read it
// is a doc change. In a review that must not save the suggestion.
export function onlyTogglesDetails(transaction: Transaction): boolean {
	return (
		transaction.docChanged &&
		sameIgnoringOpen(transaction.before, transaction.doc)
	)
}

function sameIgnoringOpen(a: Node, b: Node): boolean {
	if (a.type !== b.type || a.text !== b.text) return false
	if (!a.sameMarkup(b) && !sameAttrsIgnoringOpen(a, b)) return false
	if (a.childCount !== b.childCount) return false
	for (let i = 0; i < a.childCount; i++) {
		if (!sameIgnoringOpen(a.child(i), b.child(i))) return false
	}
	return true
}

function sameAttrsIgnoringOpen(a: Node, b: Node): boolean {
	if (a.type.name !== "details") return false
	const { open: _a, ...restA } = a.attrs
	const { open: _b, ...restB } = b.attrs
	return (
		JSON.stringify(restA) === JSON.stringify(restB) &&
		a.marks.length === b.marks.length &&
		a.marks.every((mark, i) => b.marks[i] && mark.eq(b.marks[i]))
	)
}
